import React, { useState } from 'react';
import { Card, Button, Form, ButtonGroup, ToggleButton } from 'react-bootstrap';

const MemberAssignmentForm = ({ projects, users, organizations, onAssign, onAssignOrg }) => {
  const [scope, setScope] = useState('company'); // 'company' or 'organization'
  
  const [formData, setFormData] = useState({
    organizationId: '',
    projectId: '',
    userId: '',
    role: 'viewer'
  });

  const onChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ 
        ...prev, 
        [name]: value,
        // Reset project if organization changes
        ...(name === 'organizationId' ? { projectId: '' } : {})
    }));
  };

  const onSubmit = async e => {
    e.preventDefault();
    
    let success = false;
    if (scope === 'organization') {
        success = await onAssignOrg(formData.organizationId, formData.userId, formData.role === 'editor' ? 'org_admin' : 'org_viewer');
    } else {
        success = await onAssign({
            projectId: formData.projectId,
            userId: formData.userId,
            role: formData.role
        });
    }

    if (success) {
      alert('Access assigned successfully');
      setFormData({
        organizationId: '',
        projectId: '',
        userId: '',
        role: 'viewer'
      });
    }
  };

  const filteredProjects = formData.organizationId 
    ? projects.filter(p => p.organizationId === formData.organizationId)
    : projects;

  return (
    <Card className="mb-4 shadow-sm border-0">
      <Card.Body>
        <Card.Title className="h5 mb-4 text-muted small text-uppercase font-weight-bold">
            Assign Access
        </Card.Title>

        <div className="mb-4">
            <label className="small font-weight-bold d-block mb-2">Assignment Scope</label>
            <ButtonGroup className="w-100">
                <ToggleButton
                    type="radio"
                    variant="outline-primary"
                    size="sm"
                    checked={scope === 'organization'}
                    onClick={() => setScope('organization')}
                >
                    <i className="fas fa-sitemap mr-2"></i>Organization
                </ToggleButton>
                <ToggleButton
                    type="radio"
                    variant="outline-primary"
                    size="sm"
                    checked={scope === 'company'}
                    onClick={() => setScope('company')}
                >
                    <i className="fas fa-building mr-2"></i>Specific Company
                </ToggleButton>
            </ButtonGroup>
            <div className="text-muted x-small mt-2">
                {scope === 'organization' 
                    ? "User will get access to ALL companies within the selected organization."
                    : "User will only get access to the selected company."}
            </div>
        </div>

        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className="small font-weight-bold">Select Organization</Form.Label>
            <Form.Control 
              as="select" 
              name="organizationId" 
              value={formData.organizationId} 
              onChange={onChange} 
              size="sm"
              required
            >
              <option value="">-- Select Organization --</option>
              {organizations.map(o => <option key={o._id} value={o._id}>{o.name}</option>)}
            </Form.Control>
          </Form.Group>

          {scope === 'company' && (
            <Form.Group className="mb-3">
                <Form.Label className="small font-weight-bold">Select Company</Form.Label>
                <Form.Control 
                as="select" 
                name="projectId" 
                value={formData.projectId} 
                onChange={onChange} 
                size="sm"
                required
                disabled={!formData.organizationId}
                >
                <option value="">-- Select Company --</option>
                {filteredProjects.map(p => <option key={p._id} value={p._id}>{p.name}</option>)}
                </Form.Control>
            </Form.Group>
          )}

          <Form.Group className="mb-3">
            <Form.Label className="small font-weight-bold">Select User</Form.Label>
            <Form.Control 
              as="select" 
              name="userId" 
              value={formData.userId} 
              onChange={onChange} 
              size="sm"
              required
            >
              <option value="">-- Select User --</option>
              {users.map(u => <option key={u._id} value={u._id}>{u.name} ({u.username || u.phone})</option>)}
            </Form.Control>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="small font-weight-bold">Role</Form.Label>
            <Form.Control 
              as="select" 
              name="role" 
              value={formData.role} 
              onChange={onChange}
              size="sm"
            >
              <option value="viewer">{scope === 'organization' ? 'Org Viewer (Read All)' : 'Viewer (Read Only)'}</option>
              <option value="editor">{scope === 'organization' ? 'Org Admin (Full Access)' : 'Editor (Can Edit)'}</option>
            </Form.Control>
          </Form.Group>

          <Button type="submit" variant="success" size="sm" block>
            Assign Access
          </Button>
        </Form>
      </Card.Body>
      <style dangerouslySetInnerHTML={{ __html: `
        .x-small { font-size: 0.7rem; }
      `}} />
    </Card>
  );
};

export default MemberAssignmentForm;
